import { Vector3 } from '@babylonjs/core';
import { ObjectPart } from './BabylonObjectLoader';

export class SceneObjectUtil {
  public static getObjectCenterAndSize(objectParts : ObjectPart[]) : {
    vecObjCenter : Vector3,
    vecObjSize : Vector3
  } {

    let objBBMin : Vector3 | undefined;
    let objBBMax : Vector3 | undefined;

    objectParts.forEach((objectPart) => {
      if (objectPart.meshes) {
        objectPart.meshes.meshes.forEach((mesh) => {
          if (mesh.getTotalVertices() > 0) {
            const meshBoundingInfo = mesh.getBoundingInfo();
            const meshBoudingBox = meshBoundingInfo.boundingBox;
            const bbMin = meshBoudingBox.minimumWorld;
            const bbMax = meshBoudingBox.maximumWorld;

            if (objBBMin === undefined) {
              objBBMin = new Vector3(bbMin.x, bbMin.y, bbMin.z);
            } else {
              if (bbMin.x < objBBMin.x) objBBMin.x = bbMin.x;
              if (bbMin.y < objBBMin.y) objBBMin.y = bbMin.y;
              if (bbMin.z < objBBMin.z) objBBMin.z = bbMin.z;
            }

            if (objBBMax === undefined) {
              objBBMax = new Vector3(bbMax.x, bbMax.y, bbMax.z);
            } else {
              if (bbMax.x > objBBMax.x) objBBMax.x = bbMax.x;
              if (bbMax.y > objBBMax.y) objBBMax.y = bbMax.y;
              if (bbMax.z > objBBMax.z) objBBMax.z = bbMax.z;
            }
          }
        });
      }
    });

    if (objBBMin === undefined || objBBMax === undefined) {

      return {
        vecObjCenter: new Vector3(0, 0, 0),
        vecObjSize: new Vector3(1, 1, 1),
      };
    }

    const vecObjSize = new Vector3(
      objBBMax.x - objBBMin.x,
      objBBMax.y - objBBMin.y,
      objBBMax.z - objBBMin.z,
    );

    const vecObjCenter = new Vector3(
      objBBMin.x + (objBBMax.x - objBBMin.x) / 2,
      objBBMin.y + (objBBMax.y - objBBMin.y) / 2,
      objBBMin.z + (objBBMax.z - objBBMin.z) / 2,
    );

    return { vecObjCenter, vecObjSize };
  }
}
